<template>
  <el-upload
    class="image-uploader"
    :headers="uploadHeaders"
    :action="uploadAction"
    :auto-upload="false"
    :show-file-list="false"
    :on-change="handleChange"
  >
    <el-progress
      class="image-uploader-progress"
      v-if="percentage > 0 && percentage < 100"
      type="circle"
      :percentage="percentage">
    </el-progress>
    <el-image v-else-if="url"
      :src="url"
      class="image"
      fit="contain"
    ></el-image>
    <i v-else class="el-icon-plus image-uploader-icon"></i>
    <CropperDialog ref="cropperDialog" @submit="handleCropSubmit"></CropperDialog>
  </el-upload>
</template>

<script>
import CropperDialog from '@/components/common/CropperDialog';

export default {
  components: {
    CropperDialog,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    url: {
      type: String,
    },
    uploadScope: {
      type: String,
      default() {
        return 'image';
      },
    },
    uploadLimit: {
      type: Number,
      default() {
        return 200 * 1024;
      },
    },
  },
  data() {
    return {
      uploadType: 'image',
      percentage: 0,
    };
  },
  computed: {
    uploadAction() {
      return `/api/upload/images?scope=${this.uploadScope}`;
    },
    uploadHeaders() {
      return {
        authorization: `Bearer ${this.$store.getters.token}`,
      };
    },
  },
  methods: {
    handleUploadSuccess({ url }) {
      this.$emit('uploadSuccess', url);
    },
    handleChange(file) {
      // 打开弹窗编辑
      this.$refs.cropperDialog.show({ ...this.options, file });
    },
    handleCropSubmit() {
      this.$refs.cropperDialog.setCheckFunc(this.handleBeforeUpload);
      this.$refs.cropperDialog.upload(this.uploadAction).then((res) => {
        this.handleUploadSuccess(res);
      });
    },
    handleBeforeUpload(file) {
      const validType = new RegExp(this.uploadType).test(file.type);
      const validSize = file.size < this.uploadLimit;

      if (!validType) {
        this.$message.error('上传文件格式错误');
      }
      if (!validSize) {
        this.$message.error('上传文件大小超出限制');
      }
      return validType && validSize;
    },
    handleProgress(e) {
      this.percentage = Math.trunc(e.percent);
    },
  },
};
</script>

<style lang="scss" scoped>
$size: 178px;
.image-uploader-progress {
  width: $size;
  height: $size;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: $size;
  height: $size;
  line-height: $size;
  text-align: center;
}
.image {
  width: $size;
  height: $size;
  display: block;
}
</style>
<style lang="scss">
.image-uploader {
  .el-upload {
    border: 1px dashed #7D7D7D;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409EFF;
    }
  }
}
</style>
